<template>
  <div class="mt-3">
    <SearchBar
      placeholder="Search cards"
      path="/api/v2/cards"
      :useAutocomplete="true"
      :filters="searchFilters"
      @search-results="handleResults" />
    <div v-if="selectedCards.length" class="d-flex align-items-center">
      <b-button size="sm" variant="success" class="mb-2" @click="handleConfirm">
        <b-icon icon="check"></b-icon>Confirm</b-button>
      <ul class="list-inline mb-0 ml-2">
        <CardPreview v-for="card in selectedCards" :key="`selected_card_${card.id}`"
          :card="card"
          @remove-card="handleRemoveCard" />
      </ul>
    </div>
    <div class="scrollable-window">
      <div class="row">
        <div v-if="emptyResults" class="col"><p class="text-center"><em>No cards found matching your search query.</em></p></div>
        <div class="col-4" v-for="(card, index) in cards"
          :key="`default_card_${index}`">
          <Card :card="card" :selected="!!selectedCards.find((c) => c.id === card.id)"
          @card-selected="handleCardSelected" @remove-card="handleRemoveCard" />
        </div>
        <div class="col-4" v-for="(card, index) in cardResults"
          :key="`default_card_${index}`">
          <Card :card="card" :selected="!!selectedCards.find((c) => c.id === card.id)"
            @card-selected="handleCardSelected" @remove-card="handleRemoveCard" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Card from './Card.vue';
import CardPreview from './CardPreview.vue';
import SearchBar from '../../components/SearchBar.vue';

export default {
  components: { Card, CardPreview, SearchBar },

  data() {
    return {
      query: null,
      cardResults: [],
      emptyResults: false,
      selectedCards: [],
      searchFilters: [],
    };
  },

  mounted() {
    this.searchFilters = [
      {
        title: 'Card type', type: 'select', field: 'card_type_id', options: this.cardTypes,
      },
      {
        title: 'Mine', type: 'checkbox', field: 'user_id', value: this.userId,
      },
    ];
  },

  computed: {
    ...mapState(['defaultCards', 'userId', 'cardTypes']),
    ...mapGetters(['scheduleCards']),

    cards() {
      return this.cardResults.length ? [] : this.defaultCards;
    },
  },

  methods: {
    ...mapMutations(['addCards']),

    handleCardSelected(card) {
      this.selectedCards.push(card);
    },

    handleConfirm() {
      const formattedCards = this.selectedCards.map((sc) => ({
        card_id: sc.id,
        title: sc.title,
        image: sc.image,
        position: this.scheduleCards.length + 1,
      }));
      this.addCards(formattedCards);
      this.$emit('cards-added');
    },

    handleResults(results, showEmptyMsg) {
      this.cardResults = results;
      this.emptyResults = showEmptyMsg;
    },

    handleRemoveCard(card) {
      const index = this.selectedCards.findIndex((c) => c.id === card.id);
      this.selectedCards.splice(index, 1);
    },
  },
};
</script>
